<template>
    <div>
        <app-new-breadcrumb></app-new-breadcrumb>
        <div class="row main-content">
            <div class="form-group main-card">
                <div class="panel rounded main-panel">
                    <div class="row">
                        <div class="col-lg-12">
                            <h3>{{ $t("businessUnitsMap") }}</h3>
                            <hr />
                        </div>
                        <div class="col-lg-12 form-group">
                            <div id="image-map">
                                <img src="../../../assets/bihMapa.jpg" alt="Our Locations" style="width:100%; max-height: 80vh; min-height: 80vh;"
                                    v-on:mouseover="hoverPinPoint(null)" class="rounded">
                                <div v-for="businessUnit in businessUnitsAndBranchOffices" v-bind:key="businessUnit.id"
                                    class="pin badge rounded-circle text-white"
                                    :class="{ 'bg-danger': hoveredPinPoint && (hoveredPinPoint == businessUnit.id || hoveredPinPoint == businessUnit.parentId), 'bg-success p-1': businessUnit.parentId == null, 'bg-warning': businessUnit.parentId != null }"
                                    :style="{ left: businessUnit.positionX + '%', top: businessUnit.positionY + '%' }"
                                    v-on:mouseover="hoverPinPoint(businessUnit.id)">
                                    <i class="test" :class="businessUnit.icon"></i>
                                    <div class="card text-dark" v-show="hoveredPinPoint == businessUnit.id">
                                        <div class="card-body">
                                            <span class="d-block">{{ businessUnit.businessUnit }}</span>
                                            <hr />
                                            <div class="d-block form-group text-left font-weight-normal"><i
                                                    class="fa fa-phone mr-3"></i><a
                                                    v-bind:href="'call:' + businessUnit.phone">{{ businessUnit.phone
                                                    }}</a>
                                            </div>
                                            <div class="d-block form-group text-left font-weight-normal"><i
                                                    class="fa fa-map-marker mr-3"></i>{{ businessUnit.address }}</div>
                                            <div class="d-block text-left font-weight-normal"><i
                                                    class="fa fa-envelope mr-3"></i>{{ businessUnit.ppt }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <hr />
                            <div class="d-inline-block">
                                <span class="badge rounded-circle text-white bg-success">
                                    <i class="fa fa-building"></i>
                                </span>
                                <span class="small text-muted">
                                    {{ $t("businessUnit") }}
                                </span>
                            </div>
                            <div class="d-inline-block ml-3" v-if="showBranchOffices">
                                <span class="badge rounded-circle text-white bg-warning">
                                    <i class="fa fa-map-marker"></i>
                                </span>
                                <span class="small text-muted">
                                    {{ $t("branchOffice") }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group main-card">
                <div class="panel rounded main-panel">
                    <div class="card-item rounded pt-2 pr-3 pl-3 pb-1">
                        <div class="row">
                            <div class="col-lg-12">
                                <h3>{{ $t("listOfBusinessUnits") }}</h3>
                                <hr />
                                <div class="row pt-2 pr-3 pl-3 pb-1 text-left business-unit-header">
                                    <div class="col-md-3 col-6 form-group mb-2 pr-1 pl-2">
                                        <div class="small text-muted">{{ $t("businessUnit") }}
                                    </div>
                                </div>
                                <div class="col-md-3 col-6 form-group mb-2 pr-1 pl-2">
                                    <div class="small text-muted">{{ $t("address") }}</div>
                                </div>
                                <div class="col-md-3 col-6 form-group mb-2 pr-1 pl-2">
                                    <div class="small text-muted">{{ $t("phone") }}</div>
                                </div>
                                <div class="col-md-3 col-6 form-group mb-2 pr-1 pl-2">
                                    <div class="small text-muted">{{ $t("email") }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="business-unit-list col-12" style="overflow-y: auto; max-height: 80vh; min-height: 80vh;">
                            <app-business-unit-item v-for="businessUnit in businessUnits" v-bind:key="businessUnit.id"
                                v-bind:businessUnit="businessUnit"
                                v-on:mouseover.native="hoverPinPoint(businessUnit.id)"
                                v-on:mouseleave.native="hoverPinPoint(null)"></app-business-unit-item>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BusinessUnitItem from './BusinessUnitItem.vue'
import { businessUnits } from '../../../assets/staticData/businessUnits'
import { mapGetters } from "vuex"
import Breadcrumb from "../../common/Breadcrumb.vue";


export default {
    data() {
        return {
            hoveredPinPoint: null,
            showBranchOffices: true
        }
    },
    computed: {
        ...mapGetters(["getContentById", "getContentByUrl"]),
        businessUnitsAndBranchOffices() {
            return this.showBranchOffices ? businessUnits.sort((a, b) => { a.businessUnit - b.businessUnit }) : businessUnits.filter(bu => !bu.parentId).sort((a, b) => { a.businessUnit - b.businessUnit });
        },
        businessUnits() {
            return businessUnits.filter(bu => !bu.parentId).sort((a, b) => { a.businessUnit - b.businessUnit });
        },
    },
    components: {
        AppBusinessUnitItem: BusinessUnitItem,
        appNewBreadcrumb: Breadcrumb,

    },
    methods: {
        hoverPinPoint(id) {
            this.hoveredPinPoint = id;
        }
    }
};


</script>

<style scoped>
.main-content {
    margin-left: 7%;
    margin-right: 7%;
    gap: 14px;
    display: flex;
}

.main-card{
    width: calc(50% - 7px);
}

.panel {
    padding: 3%;
    /* background-color: #FFF; */
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0px 2px 6px 1px rgba(0, 0, 0, 0.15);
    min-height: 100%;
}

.main-panel {
    background-color:  var(--light-color);
}

.card-item {
    width: 100%;
    color: var(--main-color);
}


h3 {
    color: var(--main-color);
    font-size: 24px;
    /* letter-spacing: -1px; */
    font-weight: 600;
}

.validation-error {
    border: 1px solid red;
}

.btn {
    border-color: var(--main-color);
    color: var(--main-color);
}

.btn:hover {
    background-color: var(--main-color);
    color: white;
}


textarea {
    min-height: 100px;
}

.validation-error {
    border: 1px solid red;
}

.width-65 {
    width: 65% !important;
}

.width-35 {
    width: 35% !important;
}


#image-map {
    position: relative;
}

.pin {
    position: absolute;
    background-color: var(--light-color);
    cursor: pointer;
}

.card {
    position: absolute;
    bottom: 80%;
    left: 50%;
    z-index: 3;
    box-shadow: 0px 5px 6px 1px rgba(0, 0, 0, 0.33);
}

.small{
    font-size: .8rem !important;
}

.business-unit-list {
    /* overflow-y: auto; */
    max-height: 80vh;
    min-height: 80vh;
}

.business-unit-list::-webkit-scrollbar {
    width: 6px;
}

.business-unit-list::-webkit-scrollbar-thumb {
    background-color: var(--secondary-color-hover);
    border-radius: 4px;
}

.business-unit-list::-webkit-scrollbar-track {
    background-color:  var(--secondary-color);
}

@media only screen and (max-width: 992px) {
    .main-content{
        flex-direction: column;
    }
    .main-card{
        width: 100%;
    }
    
}

@media only screen and (max-width: 650px) {
    .pin .test {
        font-size: 8px;
    }

    .pin {
        padding-left: 3px;
        padding-top: 1px;
        padding-bottom: 1px;
        padding-right: 3px;
    }
}
</style>
